import { z } from 'zod';
import { paginationQuerySchema } from './common.js';
/** Filtres de consultation du journal d'audit (écran de consultation + API). */
export const auditQuerySchema = paginationQuerySchema.extend({
    utilisateurId: z.coerce.number().int().positive().optional(),
    module: z.string().max(60).optional(),
    action: z.string().max(80).optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
});
//# sourceMappingURL=audit.js.map